import { putWithProgress } from './putWithProgress'
import type { UploadTransport } from './transport'
import type { UploadTicket } from './types'

export interface SingleOptions {
  transport: UploadTransport
  signal?: AbortSignal
  onProgress?: (bytesSent: number) => void
}

/**
 * Sube un archivo pequeño de una sola vez.
 *
 * Sin reanudación: por debajo del umbral de multiparte (100 MiB) reintentar
 * entero sale más barato que la contabilidad de partes. La reanudación existe
 * justamente para los archivos donde perder el progreso duele.
 */
export async function uploadSingle(
  file: File,
  ticket: UploadTicket,
  options: SingleOptions,
): Promise<void> {
  const presigned = ticket.upload

  if (!presigned) {
    throw new Error('El ticket no trae URL de subida.')
  }

  await putWithProgress(presigned.url, file, {
    signal: options.signal,
    headers: presigned.headers,
    retries: 5,
    // El PUT simple no necesita ETag: el backend obtiene el definitivo con
    // HeadObject al completar.
    requireEtag: false,
    onProgress: options.onProgress,
  })

  if (options.signal?.aborted) return

  await options.transport.completeUpload(ticket.session_id, [])
}
